module.exports = __webpack_public_path__ + "img/phone.8b2f97f7.svg";